// extracted by mini-css-extract-plugin
export default {"centered":"Footer_centered__JATMS","icon":"Footer_icon__c6O5j","discordBtn":"Footer_discordBtn__15ATP","main_footer":"Footer_main_footer__wnbu2","footer":"Footer_footer__AYDmA"};